import wrapWithProvider from "./src/wrapWithElements";
export const wrapRootElement = wrapWithProvider;

